import { selectOrganizationSettingsViewModel } from "@/features/management-settings/view-models/select-organization-settings-view-model";
import { Button } from "@spz/ui/components/button";
import { Form, FormField } from "@spz/ui/components/form";
import { Section } from "@spz/ui/components/section";
import {
  Select,
  SelectContent,
  SelectGroup,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@spz/ui/components/select";
import { Separator } from "@spz/ui/components/separator";
import { TextField } from "@spz/ui/components/textfield";
import { Toggle } from "@spz/ui/components/toggle";
import { useTranslation } from "react-i18next";

export const OrganizationSettings = () => {
  const { t } = useTranslation();
  const {
    organization,
    handleLanguageChange,
    isOrganizationPending,
    ssoConnection,
    isAutoMembershipEnabled,
    handleToggleChange,
    handleSsoRequest,
    form,
  } = selectOrganizationSettingsViewModel();

  return (
    <div className="flex flex-col gap-4 w-1/2">
      <TextField
        value={organization.name}
        disabled
        readOnly
        placeholder={t("organization_settings_name")}
        floatingPlaceholder
        data-testid="org-settings-name-input"
      />

      <Form {...form}>
        <form>
          <FormField
            control={form.control}
            name="language"
            render={({ field, fieldState }) => (
              <Select
                value={field.value}
                onValueChange={(val) => {
                  field.onChange(val);
                  handleLanguageChange(val);
                }}
              >
                <SelectTrigger
                  placeholder={t("preferred_language")}
                  floatingPlaceholder
                  error={fieldState.error}
                  helperText={t("preferred_language_description")}
                >
                  <SelectValue />
                </SelectTrigger>
                <SelectContent>
                  <SelectGroup>
                    <SelectItem value="fr">{t("french")}</SelectItem>
                    <SelectItem value="en">{t("english")}</SelectItem>
                  </SelectGroup>
                </SelectContent>
              </Select>
            )}
          />
        </form>
      </Form>

      <Separator className="my-2" />

      <div
        className="flex flex-col gap-4"
        data-testid="org-settings-sso-section"
      >
        <Section
          title={t("sso_settings_title")}
          description={
            ssoConnection
              ? t("sso_active_connection", { connection: ssoConnection.name })
              : t("sso_inactive_connection")
          }
        >
          {!ssoConnection && !isOrganizationPending && (
            <Button className="w-min mt-4" onClick={handleSsoRequest}>
              {t("sso_settings_configure")}
            </Button>
          )}
        </Section>

        {ssoConnection && !isOrganizationPending && (
          <div className="flex justify-between items-center">
            <Section
              title={t("auto_membership_title")}
              description={t("auto_membership_description")}
            />
            <Toggle
              checked={isAutoMembershipEnabled}
              onCheckedChange={handleToggleChange}
            />
          </div>
        )}
      </div>
    </div>
  );
};
